<div class="opciones">
    <div class="col-md-12">
        <p>Eliga la opción hacia donde quiere ir.</p>
    </div>
    <div class="col-md-12">
        <button mat-raised-button color="primary" (click)="totem_busqueda()">Búsqueda de propiedad</button>
    </div>

    <!-- 
    <div class="col-md-12">
        <button mat-raised-button class="btn btn-primary" (click)="sign('busqueda_dir')">Búsqueda de propiedad</button>
    </div>
        
    <div class="col-md-12" style="margin-bottom: 10px; padding-top: 10px;">
        <button mat-raised-button color="primary" (click)="sign('seguimiento_correspondencia')">Seguimiento de Correspondencia</button>
    </div>
    <div class="col-md-12" style="margin-bottom: 10px;">
        <button mat-raised-button color="primary" (click)="sign('seguimiento_fotocopia')">Seguimiento de Fotocopias</button>
    </div> 
    -->

    <!-- <div class="col-md-12" style="padding-top: 10px;">
        <a target="_blank" href="http://laflorida.filedom.cl/seguimiento_solicitudes/">
        <button mat-raised-button color="primary" (click)="sign('seguimiento_expediente')">Seguimiento Expendientes</button>
            </a>
    </div> -->
</div>